import { Cookies } from 'react-cookie';

import { ACCESS_TOKEN_COOKIE } from './constants';

export const logout = () => {
  const cookies = new Cookies();
  cookies.remove(ACCESS_TOKEN_COOKIE, { path: '/' });
  cookies.remove(ACCESS_TOKEN_COOKIE, { path: '' });
};
